import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetNewTicketsQuery } from '../../store/api/doctorApi';
import PageLoader from '../../components/PageLoader';
import { formatDateOnly } from '../../utils/helpers';

const DoctorNewTickets: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading, error } = useGetNewTicketsQuery(undefined);

  if (isLoading) {
    return <PageLoader />;
  }

  if (error) {
    return (
      <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
        <div className="alert alert-danger m-5">Error loading new tickets</div>
      </div>
    );
  }

  const newTickets = data?.data || [];

  return (
    <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
      <div className="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
          <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
            <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
              <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">New Tickets</h1>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <li className="breadcrumb-item text-muted">
                  <a href="#" className="text-muted text-hover-primary">Home</a>
                </li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item text-muted">New Tickets</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div id="kt_app_content" className="app-content flex-column-fluid">
          <div id="kt_app_content_container" className="app-container container-fluid">
            <div className="row justify-content-center">
              <div className="col-12 col-xl-10">
                <div className="card card-flush">
                  <div className="card-header pt-5">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bold text-dark">New Tickets</span>
                      <span className="text-gray-400 mt-1 fw-semibold fs-6">Tickets waiting to be assigned</span>
                    </h3>
                  </div>
                  <div className="card-body pt-0">
                    <div className="table-responsive">
                      <table className="table align-middle table-row-dashed fs-6 gy-5">
                        <thead>
                          <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                            <th>#</th>
                            <th>Ticket ID</th>
                            <th>User</th>
                            <th>Subject</th>
                            <th>Created At</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody className="fw-semibold text-gray-600">
                          {newTickets.length === 0 ? (
                            <tr>
                              <td colSpan={6} className="text-center py-10">
                                <span className="text-muted">No new tickets found</span>
                              </td>
                            </tr>
                          ) : (
                            newTickets.map((ticket: any, index: number) => (
                              <tr key={ticket.id}>
                                <td>{index + 1}</td>
                                <td>#{ticket.id}</td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    {ticket.user?.picture && (
                                      <img src={ticket.user.picture} alt={ticket.user?.name || 'User'} className="w-30px h-30px rounded-circle me-3" />
                                    )}
                                    <div>
                                      <div className="fw-bold">{ticket.user?.name || 'N/A'}</div>
                                      <div className="text-muted fs-7">{ticket.user?.email || ''}</div>
                                    </div>
                                  </div>
                                </td>
                                <td>{ticket.subject || 'N/A'}</td>
                                <td>{formatDateOnly(ticket.created_at)}</td>
                                <td>
                                  <button
                                    className="btn btn-sm btn-light-primary"
                                    onClick={() => navigate(`/doctor/ticket/${ticket.id}`)}
                                  >
                                    View
                                  </button>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorNewTickets;

